import { render, staticRenderFns } from "./personalData.vue?vue&type=template&id=6c9cee77&scoped=true&"
import script from "./personalData.vue?vue&type=script&lang=js&"
export * from "./personalData.vue?vue&type=script&lang=js&"
import style0 from "./personalData.vue?vue&type=style&index=0&id=6c9cee77&prod&scoped=true&lang=scss&"
import style1 from "./personalData.vue?vue&type=style&index=1&id=6c9cee77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9cee77",
  null
  
)

export default component.exports